import { Typography } from "antd";

const { Title, Paragraph } = Typography;

export const Home = () => {
  return (
    <div className="bg-[#1A1A1A] min-h-screen">
      {/* Hero Section */}
      <section className="w-full pb-20 px-4">
        <div className="container mx-auto max-w-6xl">
          <Title
            level={1}
            className="text-4xl md:text-5xl font-normal text-[#00A8E8] mb-8 tracking-wider force-blue-title font-azonix"
            style={
              {
                color: "#00A8E8 !important",
                margin: "0 0 2rem 0",
                WebkitTextFillColor: "#00A8E8 !important",
              } as React.CSSProperties
            }
          >
            <span style={{ color: "#00A8E8 !important" }}>WELCOME TO ESTABROOK INC.</span>
          </Title>
          <div className="max-w-4xl">
            <Paragraph
              className="text-white text-lg leading-relaxed white-text-force"
              style={
                {
                  color: "white !important",
                  fontSize: "18px",
                  lineHeight: "1.8",
                  WebkitTextFillColor: "white !important",
                } as React.CSSProperties
              }
            >
              <span style={{ color: "white !important" }}>
                Professional snow removal services in the Truckee area. We combine experienced
                operators with high-performance New Holland tractors to deliver reliable, efficient
                snow clearing for your property. Our goal is to provide exceptional service that
                exceeds expectations in the Tahoe Donner community.
              </span>
            </Paragraph>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section
        className="w-full py-20 px-4"
        style={{
          backgroundImage: "url('/assets/images/background-darker.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <Title
                level={2}
                className="text-3xl font-bold text-[#00A8E8] mb-8 tracking-wider force-blue-title font-azonix"
                style={
                  {
                    color: "#00A8E8 !important",
                    margin: "0 0 2rem 0",
                    fontWeight: "bold !important",
                    WebkitTextFillColor: "#00A8E8 !important",
                  } as React.CSSProperties
                }
              >
                <span style={{ color: "#00A8E8 !important" }}>OUR SERVICES</span>
              </Title>
              <Paragraph
                className="text-white text-base leading-relaxed mb-4 white-text-force"
                style={
                  {
                    color: "white !important",
                    fontSize: "16px",
                    lineHeight: "1.7",
                    WebkitTextFillColor: "white !important",
                  } as React.CSSProperties
                }
              >
                <span style={{ color: "white !important" }}>
                  Experience the difference with our advanced New Holland tractors featuring 140-155
                  horsepower engines and 98" wide snow blower boxes. Our hand-picked, experienced
                  operators ensure your driveway is cleared efficiently and thoroughly, every time.
                </span>
              </Paragraph>
            </div>
            <div>
              <img
                src="/assets/images/estabrook-truck.png"
                alt="Professional snow removal equipment"
                className="w-full h-64 object-cover shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="w-full bg-[#2A2A2A] py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto bg-[#1A1A1A] p-12">
            <div className="text-center">
              <div className="flex justify-center mb-1">
                <div className="w-24 h-24 flex items-center justify-center bg-transparent">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="#00A8E8"
                    viewBox="0 0 256 256"
                  >
                    <path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"></path>
                  </svg>
                </div>
              </div>
              <div
                className="ant-typography !text-white font-bold text-lg mb-0 uppercase tracking-wider font-azonix"
                style={{ marginBottom: 0 }}
              >
                Email Us
              </div>
              <div className="ant-typography !text-white text-lg mb-0" style={{ marginBottom: 0 }}>
                contact@estabrookinc.com
              </div>
              <div className="ant-typography !text-white text-sm mb-0" style={{ marginBottom: 0 }}>
                We respond within 24 hours
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
